"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareTwoDates = exports.transformObjectForSelect = exports.countDays = exports.getTomorrow = exports.getFullTimeDate = exports.getToday = exports.dateToSubtract = exports.dateToAdd = exports.daysToAdd = exports.daysToSubtract = exports.newNullableTransformParamsDate = exports.nullableTransformParamsDate = exports.transformParamsDate = exports.debouncedOnFunc = exports.status = void 0;
const tslib_1 = require("tslib");
const apiGlobalTypes_1 = require("api/types/apiGlobalTypes");
const date_fns_1 = require("date-fns");
const parsers_1 = require("api/parsers/parsers");
const lodash_1 = tslib_1.__importDefault(require("lodash"));
exports.status = { 1: 'აქტიური', 0: 'პასიური' };
exports.debouncedOnFunc = lodash_1.default.debounce((params, debouncedFunc) => {
    debouncedFunc(params);
}, 300, { maxWait: 1000 });
const transformParamsDate = (date) => {
    const dateArray = date.split('-');
    return dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0];
};
exports.transformParamsDate = transformParamsDate;
const nullableTransformParamsDate = (date) => {
    if (date === null)
        return null;
    const dateArray = date.split('-');
    return dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0];
};
exports.nullableTransformParamsDate = nullableTransformParamsDate;
const newNullableTransformParamsDate = (date) => {
    if (!date)
        return null;
    const dateArray = date.split('-');
    return dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0];
};
exports.newNullableTransformParamsDate = newNullableTransformParamsDate;
const daysToSubtract = (date, daysToSubtract) => {
    return daysToPlusOrSubtract(date, daysToSubtract, apiGlobalTypes_1.OperatorType.SUBTRACT);
};
exports.daysToSubtract = daysToSubtract;
const daysToAdd = (date, daysToAdd) => {
    return daysToPlusOrSubtract(date, daysToAdd, apiGlobalTypes_1.OperatorType.ADD);
};
exports.daysToAdd = daysToAdd;
const dateToAdd = (days, months, years) => {
    const today = new Date();
    if (days)
        today.setDate(today.getDate() + days);
    if (months)
        today.setMonth(today.getMonth() + months);
    if (years)
        today.setFullYear(today.getFullYear() + years);
    const day = today.getDate();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    return addZeroToDayOrMonth(day) + '-' + addZeroToDayOrMonth(month) + '-' + year;
};
exports.dateToAdd = dateToAdd;
const dateToSubtract = (days, months, years) => {
    const today = new Date();
    if (days)
        today.setDate(today.getDate() - days);
    if (months)
        today.setMonth(today.getMonth() - months);
    if (years)
        today.setFullYear(today.getFullYear() - years);
    const day = today.getDate();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    return addZeroToDayOrMonth(day) + '-' + addZeroToDayOrMonth(month) + '-' + year;
};
exports.dateToSubtract = dateToSubtract;
const addZeroToDayOrMonth = (dayOrMonth) => {
    return dayOrMonth < 10 ? '0' + dayOrMonth : `${dayOrMonth}`;
};
const daysToPlusOrSubtract = (date, days, operator) => {
    if (!date)
        return null;
    const newDate = new Date((0, parsers_1.transformDateParams)(date));
    const modifiedDae = operator === apiGlobalTypes_1.OperatorType.SUBTRACT ? newDate.getDate() - days : newDate.getDate() + days;
    newDate.setDate(modifiedDae);
    const day = newDate.getDate();
    const month = newDate.getMonth() + 1; // JS months are from 0 to 11
    const year = newDate.getFullYear();
    return day + '-' + month + '-' + year;
};
const getToday = (dateFormat) => {
    const formatStyle = dateFormat ?? 'dd-MM-yyyy';
    return (0, date_fns_1.format)(new Date(), formatStyle);
};
exports.getToday = getToday;
const getFullTimeDate = (dateStr) => {
    if (dateStr === null)
        return null;
    return (0, date_fns_1.format)(new Date(dateStr), 'dd/MM/yyyy - HH:mm:ss');
};
exports.getFullTimeDate = getFullTimeDate;
const getTomorrow = (dateFormat) => {
    const formatStyle = dateFormat ?? 'dd-MM-yyyy';
    const currentDate = new Date();
    return (0, date_fns_1.format)(currentDate.setDate(currentDate.getDate() + 1), formatStyle);
};
exports.getTomorrow = getTomorrow;
const countDays = (dateString, numberOfDays, warningMessage, dangerMessage) => {
    if (!dateString)
        return null;
    const date = new Date();
    date.setDate(date.getDate() + (numberOfDays || 30));
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const isToday = today.getTime() === new Date(new Date(dateString).setHours(0, 0, 0, 0)).getTime();
    if (today > new Date(dateString) || isToday) {
        return { type: 'danger', message: dangerMessage || 'ამ თარიღში დანიშვნა შეუძლებელია!' };
    }
    else if (date > new Date(dateString)) {
        return { type: 'warning', message: warningMessage || 'არჩეული თარიღი მოიცავს შესრულების მოკლე ვადას. გთხოვთ, გაითვალისწინოთ!' };
    }
    return null;
};
exports.countDays = countDays;
const transformObjectForSelect = (statuses) => {
    return Object.entries(statuses).map(el => { return { id: el[0], label: el[1] }; });
};
exports.transformObjectForSelect = transformObjectForSelect;
const compareTwoDates = (firstDate, secondDate) => {
    return new Date((0, exports.transformParamsDate)(firstDate)) > new Date((0, exports.transformParamsDate)(secondDate));
};
exports.compareTwoDates = compareTwoDates;
